import { TOGGLE_USER_MENU } from "./displayUserMenuReducer"

export const toggleUserMenu = (value) => ({
    type: TOGGLE_USER_MENU,
    payload: value
})